// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2bKnh","list":"styles_list__lQvap"};